module.exports = __webpack_public_path__ + "static/img_4482-0f09575e47ce345deed85d8bc8d4e47d.webp";